import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../../models/report.model';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-notes-edit-mode',
  templateUrl: './notes-edit-mode.component.html',
  styleUrls: ['./notes-edit-mode.component.scss'],
})
export class NotesEditModeComponent implements OnChanges {
  @Input() notes!: Report.Notes;

  @Output() notesChanged = new EventEmitter<Report.Notes>();

  newNotes!: Report.Notes;

  notesForm = new FormGroup({
    content: new FormControl(''),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notes']) {
      this.notesForm.controls.content.setValue(this.notes.content);
    }
  }

  onContentChanged($event: Event) {
    const value = ($event.target as HTMLInputElement).value;
    this.newNotes = {
      ...this.newNotes,
      content: value,
    };
    this.notesChanged.emit(this.newNotes);
  }
}
